import { useOrganizationsQuery } from './useOrganizationsQuery';
import { useOrganizationsSearch } from './useOrganizationsSearch';

export const useOrganizations = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = useOrganizationsQuery(filters);
    const { keyword } = useOrganizationsSearch();

    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
    };
};
